import { useCallback, useMemo } from 'react';

import { IoIosArrowBack, IoMdCheckmark } from 'react-icons/io';

import { usePrescription } from '~/hooks/prescription';
import { useSequency } from '~/hooks/sequency';
import { Prescription, Sequency } from '~/models/Sequencies';

import { Container, Label } from './styles';

type Props = {
  switchScreen: (value: boolean) => void;
  sequency: Sequency;
  prescription: Prescription;
  sequencyNumber: number;
  completed: boolean;
  prescriptionNumber: number;
};

export default function SequenceCard({
  switchScreen,
  sequency,
  sequencyNumber,
  prescription,
  completed,
  prescriptionNumber,
}: Props) {
  const { updateSequency, setSequencyLabel } = useSequency();
  const { updatePrescription } = usePrescription();

  const sequencyLabel = useMemo(() => {
    const firstValue =
      sequency.description !== `1`
        ? `Sequência ${sequencyNumber} ${` - ${
            sequency.description.split(` `)[1]
          }:`}`
        : `Sequência ${sequencyNumber}:`;

    const secondValue = completed
      ? `${firstValue} ${prescription.exercise}`
      : firstValue;

    return secondValue;
  }, [sequency, sequencyNumber, completed, prescription]);

  const handleCardClick = useCallback(() => {
    updateSequency(sequency);
    updatePrescription(sequency.prescriptions[prescriptionNumber]);
    setSequencyLabel(sequencyLabel);
    switchScreen(false);
  }, [
    updateSequency,
    sequency,
    updatePrescription,
    prescriptionNumber,
    setSequencyLabel,
    sequencyLabel,
    switchScreen,
  ]);

  return (
    <Container onClick={handleCardClick} checked={completed}>
      <Label>{sequencyLabel}</Label>
      {completed ? (
        <IoMdCheckmark color="green" size="24" />
      ) : (
        <IoIosArrowBack color="#000" size="24" />
      )}
    </Container>
  );
}
